import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import DocumentApproversForm from "./form";
import { DocumentApproverColumns } from "../../../../data/Columns/SystemSetupColumns";
import { allCourts } from "../../../../data/Queries/SetupManagement/SystemSetupQueries";
import { accountsmanagement } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import {
  allLeaveTypes,
  allUsers,allDocumentApprovers,
} from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = accountsmanagement.uri;
const actions = {
  entity: "Document Approvers ",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  removeLeaveApprover: {
    key: "REMOVE_APPROVER",
    button_name: "Remove Approver",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
};
function DocumentApproversTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Document Approvers"
          subtitle="Manage Approval Of Documents"
          columns={DocumentApproverColumns}
          FormComponent={DocumentApproversForm}
          query={allDocumentApprovers}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}


export default DocumentApproversTable;